module.exports = __webpack_public_path__ + "static/img/胶轮车不能把头伸出车外.f3c0f56c.png";